import React, { Fragment, useState, useMemo } from 'react'
import { Grid, Cell } from 'react-mdl'
import { formatDateFromDb } from '@utils'

import LoadingIndicatorModal from './loadingIndicatorModal'

const { FlatDatepicker, I18n } = window

const AddNonEventActivity = ({
  allowResultEntry,
  instructorId,
  createdAt,
  endAt,
  agencyId,
  eventsProgramEventId,
  limitReached,
  setEventProgramEvent,
  setInstructorResultDetails,
  existingEventDates,
}) => {
  const dateFormat = I18n?.t?.('date.formats.form_date_hint') || 'MM/DD/YYYY'
  const [nonEventDate, setNonEventDate] = useState(null)
  const [nonEventDateError, setNonEventDateError] = useState('')
  const [showLoadingModal, setShowLoadingModal] = useState(false)

  const placeholderText = useMemo(
    () => (limitReached ? 'Maximum Non-Event Days Reached' : 'Enter Non-Event Day Results'),
    [limitReached]
  )

  const pickerOptions = useMemo(() => {
    const disabledExistingTimestamps = existingEventDates.map(function(d) {
      const dt = new Date(d.split('T')[0] + 'T00:00')
      return dt.getTime()
    })

    const disableFn = function(date) {
      const d = new Date(date)
      d.setHours(0, 0, 0, 0)
      const t = d.getTime()
      return disabledExistingTimestamps.indexOf(t) !== -1
    }

    return {
      minDate: formatDateFromDb(createdAt, dateFormat),
      maxDate: formatDateFromDb(endAt, dateFormat),
      disable: [disableFn],
    }
  }, [createdAt, dateFormat, endAt, existingEventDates])

  const submitAddNonEventDay = (e) => {
    e.preventDefault()

    setShowLoadingModal(true)
    const createEventActivityUrl = `/events/agencies/${agencyId}/event_activities/`
    const eventActivityCreateData = {
      non_event_date: nonEventDate,
      events_program_event_id: eventsProgramEventId,
      non_event_activity: true,
      instructor_id: instructorId,
    }
    setNonEventDateError('')
    Fetchable.post(createEventActivityUrl, eventActivityCreateData)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          return response.json().then((errorData) => {
            let errorMessage = 'An error occurred'

            if (errorData.errors && Array.isArray(errorData.errors)) {
              errorMessage = errorData.errors.join(', ')
            } else if (errorData.error && typeof errorData.error === 'string') {
              errorMessage = errorData.error
            } else if (typeof errorData === 'string') {
              errorMessage = errorData
            }

            console.error('Error:', errorMessage)
            setNonEventDateError(errorMessage)
            setShowLoadingModal(false)
            throw new Error(errorMessage)
          })
        }
      })
      .then((data) => {
        setEventProgramEvent(data.program_event)
        setInstructorResultDetails(data.instructor.instructor_result_details)
        setNonEventDate(null)
        setNonEventDateError('')
        setShowLoadingModal(false)
      })
  }

  return (
    <Fragment>
      {showLoadingModal && <LoadingIndicatorModal title="Adding Non-Event Day" />}
      <fieldset disabled={limitReached}>
        <Grid className="mdl-grid--nested u-margin--bottom-3">
          <Cell col={6}></Cell>
          <Cell col={4}>
            <FlatDatepicker
              disabled={limitReached || !allowResultEntry}
              dateFormat={dateFormat}
              value={nonEventDate ? formatDateFromDb(nonEventDate, dateFormat) : ''}
              onChange={(dates) => setNonEventDate(dates[0])}
              error={nonEventDateError ? nonEventDateError : ''}
              options={pickerOptions}
              placeholder={placeholderText}
              key={existingEventDates}
            />
          </Cell>
          <Cell col={2} style={{ paddingTop: '11px', marginRight: '0' }}>
            <button
              id="nonEventDateSubmitBtn"
              className="mdl-button mdl-button--colored mdl-js-button u-pull--right"
              onClick={submitAddNonEventDay}
              disabled={limitReached || showLoadingModal || !nonEventDate}
              style={{ marginRight: '0' }}>
              Add Non Event Day
            </button>
          </Cell>
        </Grid>
      </fieldset>
    </Fragment>
  )
}

export default AddNonEventActivity
